import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';
import * as moment from "moment";
import { Receipt, User } from '@shared/models';
import { AuthGuardService, CommercialService, UserService } from '@core/services';

@Component({
  selector: 'app-confirm-payment',
  templateUrl: './confirm-payment.component.html',
  styleUrls: ['./confirm-payment.component.css']
})
export class ConfirmPaymentComponent implements OnInit, OnDestroy {
  private user: User;
  private subscription: Subscription;
  public receiptInfo: any;
  public paymentSubmitted = false;
  public isApproved = false;
  public isDisabled = false;
  public receipt: Receipt = new Receipt();
  public feeArray: any = {};
  public feeTotal = 0;
  public showAccountButton = false;
  public isCommercialCustomer = false;
  public continueRoute = "/account";
  referralCode = "";


  constructor(private authGuard: AuthGuardService,
    private _userService: UserService,
    private dialog: MatDialog,
    private _commercialService: CommercialService) {
  }

  ngOnInit() {
    //this._authGuard.getCurrentUser();
    this.subscription = this._userService.getUser().subscribe(user => {
      console.log(user)
      this.user = user;
      console.log(this.user)
      // console.log(this.user)
      this.getFees();
      this._commercialService.getCommercialValue().subscribe(isCommercial => {
        this.isCommercialCustomer = isCommercial.isCustomerCommercial;
      });
      // console.log("tried to get fees")
    });
    this.referralCode = localStorage.getItem('referralCode') ? localStorage.getItem('referralCode'): undefined;
    console.log(this.referralCode)
    //this.getFees();
  }


  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  submitPayment() {
    if (this.isDisabled) {
      return false; //disable function if already clicked first time will work
    }

    this.isDisabled = true;
    let dataToSend = this.setUpSubmitPaymentData();
    this.authGuard.authenticatedPost('portfolios/insertpayment', this.setUpSubmitPaymentData()).subscribe(
      result => {
        console.log('insertPayment Return', result);
        this.receiptInfo = result;
        this.isApproved = this.receiptInfo.IsApproved;
        this.receipt.amount = dataToSend.PaymentAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        this.receipt.date = moment(new Date().toString()).format("lll");
        this.receipt.referenceNumber = this.receiptInfo.RetrievalReferenceNumber;
        this.receipt.accountId = dataToSend.AccountId;
        this.receipt.transactionId = this.receiptInfo.TransactionNumber;
        this.receipt.cardNumber = this.receiptInfo.CardNumber.split(' ')[2] + ' ' + this.receiptInfo.CardNumber.split(' ')[3];
        this.receipt.transactionType = this.receiptInfo.TransactionType;
        this.receipt.cardType = this.receiptInfo.CardType;
        this.receipt.responseMessage = this.receiptInfo.ResponseText;
        this.receipt.authCode = this.receiptInfo.AuthCode;
        this.receipt.avsResult = this.receiptInfo.AvsResponse;
        this.receipt.currency = this.receiptInfo.Currency;
        this.paymentSubmitted = true;
        this.showAccountButton = true;

        if (!this.isApproved) {
          this.dialog.open(ResultDialogComponent, {
            data: {
              message: this.receipt.responseMessage,
              alertType: 'danger',
              title: 'Payment Failed'
            }
          });
        }
      },
      error => {
        console.log('Error: ' + error);
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: error,
            alertType: 'danger',
            title: 'Failed to submit payment'
          }
        });
        this.receipt.responseMessage = error;
        this.isDisabled = false;
        this.paymentSubmitted = true;
      }
    );

  }

  getFees() {
    this.isDisabled = true;
    var data = this.setUpFeesData()
    if (Object.keys(data).length == 0){
      return
    }
    this.authGuard.authenticatedPost('portfolios/FeeSummary', data).subscribe(
      result => {

        this.feeArray = result;
        this.feeTotal = 0;
        for (let fee of this.feeArray) {
          this.feeTotal += fee.feeamount;
        }
        this.isDisabled = false;
      },
      error => {
        this.continueRoute = "/manageprofile/credit";
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: error,
            alertType: 'danger',
            title: 'Failed to get fees'
          }
        });
      }
    );

  }

  setUpFeesData() {
    if(this.user.customerIdArray.length > 0){
      return {
        'CustomerId': this.user.customerIdArray[this.user.customerIndex].Id,
        'AccountId': 0

      }
    } else {
      return {}
    }

  }
  setUpSubmitPaymentData() {
    console.log(this.feeTotal);
    if (this.isCommercialCustomer === true) {
      return {
        'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id,
        'CustomerId': this.user.customerIdArray[this.user.customerIndex].Id,
        'Email': this.user.email.trim(),
        'PaymentAmount': this.feeTotal,//Number((Math.random() * 10) + 1).toFixed(2), // set this.feeTotal in prod, global denies duplicate payments
        'CreditCardId': 0,
        'IsSignUp': true,
        'IsCommercial': true
      }
    }

    if (this.referralCode) {
      return {
        'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id,
        'CustomerId': this.user.customerIdArray[this.user.customerIndex].Id,
        'Email': this.user.email.trim(),
        'PaymentAmount': this.feeTotal,//Number((Math.random() * 10) + 1).toFixed(2), // set this.feeTotal in prod, global denies duplicate payments
        'CreditCardId': 0,
        'IsSignUp': true,
        'ReferralCode': this.referralCode
      }
    }
    return {
      'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id,
      'CustomerId': this.user.customerIdArray[this.user.customerIndex].Id,
      'Email': this.user.email.trim(),
      'PaymentAmount': this.feeTotal,//Number((Math.random() * 10) + 1).toFixed(2), // set this.feeTotal in prod, global denies duplicate payments
      'CreditCardId': 0,
      'IsSignUp': true
    }

  }

  formatAsDollar(amount: number) {

    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/confirm-payment/confirm-payment.component.ts